import { useCallback, useState } from "react";

let toastId = 0;

export function useToast() {
    const [toasts, setToasts] = useState([]);

    const showToast = useCallback((message, type = "info", duration = 5000) => {
        setToasts((prev) => {
            // 同じメッセージとタイプのtoastが既に存在するかチェック
            const isDuplicate = prev.some(
                (toast) => toast.message === message && toast.type === type
            );

            // 重複している場合は追加しない
            if (isDuplicate) {
                return prev;
            }

            // 重複していない場合は新しいtoastを追加
            const id = ++toastId;
            const toast = { id, message, type, duration };
            return [...prev, toast];
        });
    }, []);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);

    return { toasts, showToast, removeToast };
} 